import React from 'react';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import HelpCenterForm from '../../../components/forms/HelpCenterForm';
import { STACK_CENTER_COLUMN_DIRECTION, INFORMATION_STACK_WITH_BORDER } from '../../../constants/mui-components';
import InformationStack from '../../../components/stacks/InformationStack';

function DemoForm({ demoData }) {
  const theme = useTheme();
  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={{
        width: '100%',
        padding: { xs: '2rem', md: '3.75rem 11.25rem' },
        gap: '2.5rem',
        borderRadius: '3rem',
        background: 'linear-gradient(180deg, #18284D 0%, #000 100%)',
      }}
    >
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="1.5rem">
        <InformationStack
          className={INFORMATION_STACK_WITH_BORDER}
          text={demoData.stackText}
          variant="info_stack"
          backgroundColor={theme.palette.neutral.A600}
          textColor="white"
          fontWeight={800}
        />
        <Typography
          variant="xlarge_2"
          sx={{
            color: 'white',
            textAlign: 'center',
            fontSize: { xs: '2rem', phone: '2.5rem', md: '3rem' },
            fontWeight: 700,
            lineHeight: '120%',
          }}
        >
          {demoData.title}
        </Typography>
      </Stack>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: { xs: '2rem 2rem', ipad: '3.25rem 4rem' },
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '2rem',
          gap: '3rem',
          maxWidth: '38rem',
          width: '100%',
        }}
      >
        <Stack>
          <Typography
            variant="large_1"
            fontWeight={700}
            color={theme.palette.neutral.A700}
            textAlign="center"
            fontSize={{ xs: '1.125rem', ipad: '1.5rem' }}
            width="100%"
          >
            {demoData.cardTitle}
          </Typography>
        </Stack>
        <HelpCenterForm
          nameLabel={demoData.nameLabel}
          phoneNumberLabel={demoData.phoneNumberLabel}
          emailLabel={demoData.emailLabel}
          questionLabel={demoData.questionLabel}
          buttonText={demoData.buttonText}
          messageInputText={demoData.message}
        />
      </Card>
    </Stack>
  );
}

DemoForm.propTypes = {
  demoData: PropTypes.shape({
    stackText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    nameLabel: PropTypes.string.isRequired,
    phoneNumberLabel: PropTypes.string.isRequired,
    emailLabel: PropTypes.string.isRequired,
    questionLabel: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default DemoForm;
